import { render, staticRenderFns } from "./PatientView.vue?vue&type=template&id=37f49d5b&scoped=true"
import script from "./PatientView.vue?vue&type=script&lang=ts"
export * from "./PatientView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f49d5b",
  null
  
)

export default component.exports